import Fuse from 'fuse.js';
import * as React from 'react';
import { JSONController, URLData } from '@telia-common-components/shared';
import { TvB2BPacketDetailsContext } from './TvB2BPacketDetailsContext';
import { withAnalytics } from '../util/AnalyticsUtil';
class TvB2BPacketDetailsProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            packagesResponse: {
                packagePrices: [],
                themePackages: [],
                channels: [],
                categoriesList: {},
                additionalServices: [],
                packageNames: [],
                viewerSlots: {},
                packageSizes: []
            },
            themePackageChannelsState: 'UNINITIALIZED',
            filterState: {
                channelSuggestionItems: [],
                selectedItem: null,
                fuzzySearch: null,
                selectedPackages: [],
                selectedThemes: [],
                isAllChannelsShown: false,
                isAllThemesShown: false,
                isAllServicesShown: false
            }
        };
        this.packagesJsonController = new JSONController();
        this.urlData = new URLData({
            app: 'public',
            tier: this.props.tier,
            lang: this.props.lang
        });
        this.fuzzySearchOptions = {
            shouldSort: true,
            keys: ['label'],
            threshold: 0.2
        };
        this.getPackages = async () => {
            try {
                const response = await this.packagesJsonController.fetch(this.urlData.getTvB2BComparisonDataUrl(this.props.lang));
                await this.handlePackagesResponse(response);
                this.setFuzzyState();
            }
            catch (e) {
                this.setState({
                    packagesResponse: {
                        packagePrices: [],
                        themePackages: [],
                        channels: [],
                        categoriesList: {},
                        viewerSlots: {},
                        additionalServices: [],
                        packageNames: [],
                        packageSizes: []
                    }
                });
                console.error(e);
            }
        };
        this.setFuzzyState = () => {
            this.setState({
                filterState: {
                    ...this.state.filterState,
                    fuzzySearch: new Fuse(this.suggestionItems, this.fuzzySearchOptions)
                }
            });
        };
        this.selectSuggestionItem = (item) => {
            this.setState({
                filterState: { ...this.state.filterState, selectedItem: item }
            });
            if (item && item.label) {
                this.props.pushAnalytics(item.label);
            }
        };
        this.setSelectedThemes = (themes) => {
            this.setState({
                filterState: { ...this.state.filterState, selectedThemes: themes }
            });
            this.props.pushAnalytics(`Selected themes ${themes.concat(', ')}`);
        };
        this.setSelectedPackages = (packages) => {
            this.setState({
                filterState: { ...this.state.filterState, selectedPackages: packages }
            });
            this.props.pushAnalytics(`Selected packages ${packages.concat(', ')}`);
        };
        this.toggleAllThemesShown = (event) => {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            this.setState({
                filterState: {
                    ...this.state.filterState,
                    isAllThemesShown: !this.state.filterState.isAllThemesShown
                }
            });
            this.props.pushAnalytics('Toggle show all themes');
        };
        this.toggleAllChannelsShown = (event) => {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            this.setState({
                filterState: {
                    ...this.state.filterState,
                    isAllChannelsShown: !this.state.filterState.isAllChannelsShown
                }
            });
            this.props.pushAnalytics('Toggle show all channels');
        };
        this.toggleAllServicesShown = (event) => {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            this.setState({
                filterState: {
                    ...this.state.filterState,
                    isAllServicesShown: !this.state.filterState.isAllServicesShown
                }
            });
            this.props.pushAnalytics('Toggle show all additional services');
        };
    }
    componentDidMount() {
        this.getPackages();
    }
    handlePackagesResponse(response) {
        this.setState({
            packagesResponse: response,
            filterState: {
                ...this.state.filterState,
                selectedPackages: response.packagePrices.map((offer) => offer.name)
            }
        });
    }
    get suggestionItems() {
        return this.state.packagesResponse.channels
            .filter((channel) => ['TELIA_TV_KONTOR_A', 'TELIA_TV_MAJUTUSKOHT_A', 'TELIA_TV_TEENINDUSKOHT_A'].every((packet) => (channel === null || channel === void 0 ? void 0 : channel.includedInPackage) && !(channel === null || channel === void 0 ? void 0 : channel.includedInPackage[packet])))
            .map((c) => ({
            id: `${c.id}`,
            label: c.title,
            url: ''
        }))
            .concat((this.state.packagesResponse.themePackages || []).map((tp) => ({
            id: `${tp.productSpecId}`,
            label: `${this.props.translate(`tvcomparison.themepackages.${tp.productOfferingCode}.label`)}`,
            url: ''
        })));
    }
    render() {
        const { children } = this.props;
        return (React.createElement(TvB2BPacketDetailsContext.Provider, { value: {
                packagesResponse: this.state.packagesResponse,
                filterState: this.state.filterState,
                filterActions: {
                    selectSuggestionItem: this.selectSuggestionItem,
                    setSelectedPackages: this.setSelectedPackages,
                    setSelectedThemes: this.setSelectedThemes,
                    toggleAllThemesShown: this.toggleAllThemesShown,
                    toggleAllChannelsShown: this.toggleAllChannelsShown,
                    toggleAllServicesShown: this.toggleAllServicesShown
                },
                urlData: this.urlData
            } }, children));
    }
}
export default withAnalytics(TvB2BPacketDetailsProvider);
